/** Idempotency keys for booking creation, persisted per intent across a refresh. */

const PREFIX = 'recovry_idem:';

function randomKey(): string {
  const rand =
    typeof crypto !== 'undefined' && 'randomUUID' in crypto
      ? crypto.randomUUID().replace(/-/g, '')
      : `${Date.now().toString(36)}${Math.random().toString(36).slice(2)}${Math.random().toString(36).slice(2)}`;
  return `bk_${rand}`.slice(0, 64);
}

/** Stable key for ONE booking intent (centre+service+slot); survives a refresh. */
export function idempotencyKeyFor(intent: string): string {
  const k = PREFIX + intent;
  try {
    const existing = sessionStorage.getItem(k);
    if (existing) return existing;
    const fresh = randomKey();
    sessionStorage.setItem(k, fresh);
    return fresh;
  } catch {
    return randomKey();
  }
}

/** The booking exists now; the next attempt for this slot is a new intent. */
export function clearIdempotencyKey(intent: string): void {
  try {
    sessionStorage.removeItem(PREFIX + intent);
  } catch {
    /* ignore */
  }
}
